export type QuoteInputs = {
  hours: string;
  hourlyRate: string;
  expenses: string;
  publication: string;
  usage: string;
  exclusivity: string;
};
export function quoteFromCosts(input: QuoteInputs): { production: number; total: number } | null {
  const values = Object.values(input);
  if (values.some((value) => !value.trim() || !Number.isFinite(Number(value)) || Number(value) < 0))
    return null;
  const production = Number(input.hours) * Number(input.hourlyRate);
  const total =
    production +
    Number(input.publication) +
    Number(input.expenses) +
    Number(input.usage) +
    Number(input.exclusivity);
  return Number.isFinite(total) ? { production, total } : null;
}

export type CampaignLinkInput = {
  destination: string;
  source: string;
  medium: string;
  campaign: string;
  content: string;
};

export type CampaignLinkResult = { url: string; error?: never } | { url?: never; error: string };

/** Pure URL construction: never fetch the entered destination. */
export function buildCampaignLink(input: CampaignLinkInput): CampaignLinkResult {
  let url: URL;
  try {
    url = new URL(input.destination.trim());
  } catch {
    return { error: 'Enter a complete web address, starting with https:// or http://.' };
  }
  if (
    !['https:', 'http:'].includes(url.protocol) ||
    !url.hostname ||
    url.username ||
    url.password
  ) {
    return { error: 'Use an http:// or https:// address without sign-in details.' };
  }
  const required = [input.source, input.medium, input.campaign];
  if (required.some((value) => !value.trim())) {
    return { error: 'Add a source, medium and campaign name.' };
  }
  // Replace these fields case-insensitively so an old tag cannot compete with a new one.
  const fields = {
    utm_source: input.source,
    utm_medium: input.medium,
    utm_campaign: input.campaign,
    utm_content: input.content,
  };
  for (const key of [...url.searchParams.keys()]) {
    if (Object.hasOwn(fields, key.toLowerCase())) url.searchParams.delete(key);
  }
  for (const [key, value] of Object.entries(fields)) {
    if (value.trim()) url.searchParams.set(key, value.trim());
  }
  return { url: url.toString() };
}
